import React from 'react'
import GroupCardModal from './GroupCardModal'

// Questo era qui da prima di me, se avete rimostranze mi dispiace, le avevo anch'io
export default function DimensionGroup(props) {
    const group = props.group
    const key = group.name
    const dimensions = props.savedDimensions
    const reloadListing = props.reloadListing

    return (
      <tr key={key}>
        <td md={6} className="align-content-center ml-2">
          <h4>
            {group.name}{' '}
          </h4>
        </td>
        <td md={2} className="align-content-center">
            {group.dimensions.length}
        </td>
        <td md={2}>
          <GroupCardModal group={group} dimensions={dimensions} key={key} reloadListing={reloadListing}/>
        </td>
      </tr>
    )
}
